import type {DependencyList, ReactElement} from 'react';
import {useEffect} from 'react';
import {updatePanelPropsForModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {MoreOptionsModalProps} from '@Modals/more-options-modal/more-options-modal';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {useModalData} from '@Components/modal/hooks/useModalData';

interface UpdateMoreOptionsModalConfig {
  panelIdOpenedInModal?: string;
  additionalPanelProps?: Partial<MoreOptionsModalProps>;
}

export const useUpdateMoreOptionsModal = (updatedContent: ReactElement, dependencyArray: DependencyList, config: UpdateMoreOptionsModalConfig = {}): void => {
  const {panelIdOpenedInModal, additionalPanelProps} = config;
  const modalData = useModalData(MODALS_IDS.MORE_OPTIONS_MODAL);

  const panelInModal = useAppSelector((state) => {
    if (!panelIdOpenedInModal) {
      return null;
    }

    return state.panels.panelHashmap[panelIdOpenedInModal] ?? null;
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!modalData) {
      return;
    }

    if (panelIdOpenedInModal && panelInModal === null) {
      return;
    }

    dispatch(
      updatePanelPropsForModal({
        modalId: MODALS_IDS.MORE_OPTIONS_MODAL,
        panelProps: {
          ...modalData.panelProps,
          ...additionalPanelProps,
          content: updatedContent,
        },
      })
    );
  }, [...dependencyArray]);
};
